"use client";

import { type ReactNode, useEffect, useState } from "react";
import { isInIframe } from "./is-iframe";

type NotInIframeProps = {
	readonly children: ReactNode;
};

export const NotInIframe = ({ children }: NotInIframeProps) => {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted || isInIframe()) {
		return null;
	}

	return <>{children}</>;
};
